import { render, staticRenderFns } from "./archived.vue?vue&type=template&id=773acbd7&scoped=true"
import script from "./archived.vue?vue&type=script&lang=js"
export * from "./archived.vue?vue&type=script&lang=js"
import style0 from "./archived.vue?vue&type=style&index=0&id=773acbd7&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "773acbd7",
  null
  
)

export default component.exports